import ProductsList from "./products/ProductsList";

const Clothing = ({ title, category }) => {
  return (
    <section>
      <div className="text-center mb-8">
        <h3 className="text-4xl">{title}</h3>
      </div>
      <ProductsList filterBy={category} />
    </section>
  );
};

export default Clothing;
